import React from "react";
import "./audit-request.css";
import { useState, useEffect } from "react";
import requestAuditService from "../../services/requestAuditService";
import { toast, ToastContainer } from "react-toastify";
import { AccordionV2, AccordionItemV2, Modal, Font, Slot, Dropdown, Radio, Tab, TabsNavigation, DataTable, Icon, Button } from "pepsico-ds";
import { useTranslation } from "react-i18next";
import ServiceUnavailable from "../../common/service_unavailable";


const AuditRequestDetail = ({ onClose, requestNumber }) => {
    const { t } = useTranslation();
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [isShowModel, setIsShowModel] = useState(false);
    const [isShowReminderModel, setIsShowReminderModel] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const isValidDate = (val) => val && val !== "null" && val !== "undefined" && val.trim() !== "";
    const [requestedAppName, setAppName] = useState(null);
    const [sendReminderPayload, setSendReminderPayload] = useState({});


    // const status = auditRequestData?.auditInfoData?.[0]?.requestStatus;
    const [auditRequestData, setAuditRequestData] = useState({});
    const [selected, setSelected] = useState("");
    const [items, setItems] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [appNameLoading, setAppLoading] = useState(false);
    const [isBtnLoading, setBtnLoading] = useState(false);
    const [approverQueue, setApproverQueue] = useState([]);
    const [approverQueueList, setApproverQueueList] = useState([]);
    const [routingList, setRoutingList] = useState([]);
    const [requestDetail, setRequestDetail] = useState([]);
    const [error, setError] = useState(null);

    const openGCRStatus = (path) => {
        const w = window.screen.width * .9;
        const h = window.screen.height * .9;
        const l = window.screen.width * .05;
        const t = window.screen.height * .05;
        window.open(path, "_blank", `width=${w},height=${h},left=${l},top=${t}`);
    }

    const columns = [
        {
            columnKey: 'approverQueue',
            header: t("auditRequest.approver_queue_upper_label"),
            initialSize: 220,

        },
        {
            columnKey: 'arrivedInQueue',
            header: t("auditRequest.arrived_in_queue_label"),
            initialSize: 220
        },
        {
            columnKey: 'status',
            header: t("auditRequest.status_label"),
            initialSize: 220,
            cellData: (ctx) => {
                return <>
                    {ctx.row.original?.checkSapGrcStatus ? <div className="grc-status-link" onClick={() => openGCRStatus(ctx.row.original?.checkSapGrcStatus)}>Check GRC Status</div> : <div>{ctx.row.original.status}</div>}
                </>
            }
        },
        {
            columnKey: 'dateCompleted',
            header: t("auditRequest.date_completed_label"),
            initialSize: 220
        },
        {
            columnKey: 'approver',
            header: t("auditRequest.approver_label"),
            initialSize: 220
        },
        {
            columnKey: 'followUp',
            header: t("auditRequest.reminder"),
            minSize: 300,
            cellData: (ctx) => {
                console.log(ctx.row.original);
                return <>
                    {ctx.row.original?.followUp ?
                        <div>{
                            ctx.row.original?.allFollowupTsp?.length > 0 ?  ctx.row.original?.allFollowupTsp.map((rec)=>{
                                return <p style={{fontSize: "12px"}}>{`Follow-Up sent on ${rec}`}</p>
                            }) : null
                        }<div className="send-reminder-link" onClick={() => onClickReminder(ctx.row.original?.approverQueue)}>{t("auditRequest.send_reminder_upper_label")}</div></div> : null}
                </>
            }

        }

    ];


    const requestSupportColumns = [
        {
            columnKey: 'approver',
            header: t("auditRequest.approver_label"),
            initialSize: 220
        },
        {
            columnKey: 'email',
            header: t("auditRequest.email_upper_label"),
            initialSize: 220,
            cellData: (ctx) => {
                return <>
                    <div dangerouslySetInnerHTML={{ __html: ctx.row.original.email }}></div>
                </>
            }
        },
        {
            columnKey: 'phoneNumber',
            header: t("auditRequest.phone_number_upper_label"),
            initialSize: 220
        },
        {
            columnKey: 'ext',
            header: t("auditRequest.exist_label"),
            initialSize: 220
        },
        {
            columnKey: 'gpid',
            header: t("auditRequest.gpid_label"),
            initialSize: 220
        }
    ];

    const sendReminder = async () => {
        setBtnLoading(true);
        setError(null);
        try {
            const response = await requestAuditService.sendFollowUp(sendReminderPayload);
            if (response.data && response.data.status?.toLowerCase() === "success") {
                toast.success(t("auditRequest.reminder_sent_success_label"));
                isReminder(new Date().toISOString())
                setIsShowModel(false);
                setIsShowReminderModel(false);
                fetchRequestNumberDetail();
            } else {
                toast.error(t("auditRequest.something_went_wrong_label"));
                setBtnLoading(false);
            }
        } catch (err) {
            toast.error(err.message || t("auditRequest.api_call_failed_label"));
            setBtnLoading(false);
        } finally {
            setBtnLoading(false);
        }
    }

    const getBackgroundColor = (status) => {
        switch (status) {
            case "In Progress":
                return "#FFDCBB";
            case "Complete":
                return "#B3DACB";
            case "Failed":
                return "#F6CCD2";
            default:
                return "#E0E0E0";
        }
    };

    useEffect(() => {
        fetchRequestNumberDetail();
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const fetchRequestNumberDetail = async () => {
        try {
            setIsLoading(true);
            const data = {
                "requestNumber": requestNumber,
                "isPassword": false
            };
            const response = await requestAuditService.getAuditRequestByRequestNumber(data);
            
            if(response.data.isCancelled){
                const updatedWorkItemsMap = {};
                const appQueueArray = Object.entries(response.data.workItemsMap);
                if(appQueueArray.length){
                    appQueueArray.forEach(([appName,queueArr])=>{
                        const updatedQueueArrayStatus = queueArr.map((queueData)=>(queueData.status === "In Progress" ? {...queueData, status: "Cancelled"}: queueData));
                        updatedWorkItemsMap[appName] = updatedQueueArrayStatus;
                    })
                }
                response.data.workItemsMap = updatedWorkItemsMap;
            }

            setAuditRequestData(response.data);
            if (response.data && response.data.status == "Failed") {
                toast.error(response.data?.errorMessage);
                setError(response.data.errorMessage);
                setIsLoading(false);
                return;
            }
            // isReminder(response.data?.lastReminderRequest)
            const status = response.data.overAllStatus;
            if (!status) {
                setError(t("auditRequest.no_data_found_label"));
                setIsLoading(false);
                return;
            }
            const responseData =
                status === "Complete"
                    ? [t("auditRequest.request_submitted_label"), t("auditRequest.request_completed_label")]
                    : [t("auditRequest.request_submitted_label")];
            setItems(responseData);
            setSelected(status === "Complete" ? t("auditRequest.request_completed_label") : t("auditRequest.request_submitted_label"));
            const invalidValues = ["", "null", null, undefined, "undefined"];
            const appNames = response.data.distinctAppsList || [];
            const approvalData = response.data;

            let filteredData = approvalData;
            const requestedAppName = appNames[0];
            setAppName(requestedAppName);
            filteredData = approvalData?.workItemsMap?.[requestedAppName] || [];
            let approverDetailsMap = approvalData?.approverDetailsMap?.[requestedAppName] || [];

            console.log("filteredData:::::::", filteredData);
            const transformedData = filteredData.map(item => ({
                approverQueue: invalidValues.includes(item?.queueName) ? t("auditRequest.not_applicable") : item?.queueName,
                arrivedInQueue: invalidValues.includes(item?.dateArrived) ? t("auditRequest.not_applicable") : item?.dateArrived,
                status: invalidValues.includes(item?.status) ? t("auditRequest.not_applicable") : item?.status,
                dateCompleted: invalidValues.includes(item?.dateApproved) ? t("auditRequest.not_applicable") : item?.dateApproved,
                approver: invalidValues.includes(item?.approverGpid) ? t("auditRequest.not_applicable") : item?.approverGpid,
                followUp: approvalData?.isAppFollowupEnabled && item.followupAvailable,
                allFollowupTsp: item.allFollowupTsp,
            }));


            const transformedRoutingData = Array.isArray(approverDetailsMap)
                ? approverDetailsMap.filter((data) => `${data.fullName}`.trim?.()?.toLowerCase() !== "imyidMTeamServiceITE"?.toLowerCase?.() && Boolean(`${data.fullName}`.trim() || `${data.email}`.trim() || `${data.phoneNumber}`.trim() || `${data.ext}`.trim() || `${data.currentApproverGPID}`.trim())).map((item) => ({
                    approver: ["", "null", null, undefined, "undefined"].includes(item?.fullName)
                        ? t("auditRequest.not_applicable")
                        : item.fullName,
                    email: ["", "null", null, undefined, "undefined"].includes(item?.email)
                        ? t("auditRequest.not_applicable")
                        : item.email,
                    phoneNumber: ["", "null", null, undefined, "undefined"].includes(item?.phoneNumber)
                        ? t("auditRequest.not_applicable")
                        : item.phoneNumber,
                    ext: ["", "null", null, undefined, "undefined"].includes(item?.ext)
                        ? t("auditRequest.not_applicable")
                        : item.ext,
                    gpid: ["", "null", null, undefined, "undefined"].includes(item?.currentApproverGPID)
                        ? t("auditRequest.not_applicable")
                        : item.currentApproverGPID,
                }))
                : [];
            let approverQueueData = [];


            approverQueueData = status === "Complete" ? transformedData.filter((a) => a.status.toLowerCase() == "approved") : transformedData;
            // approverQueueData = transformedData;
            setRoutingList(transformedRoutingData);
            setApproverQueue(approverQueueData);
            setApproverQueueList(transformedData);
            getDataByStatus(status, response.data);
            setIsLoading(false);
        } catch (e) {
            setError(e.message || t("auditRequest.api_call_failed_label"));
            setIsLoading(false);
        }
    }


    const onClickReminder = (queueName) => {
        const appNames = auditRequestData?.distinctAppsList || [];
        const appName = requestedAppName ? requestedAppName : appNames[0];
        const sendReminderPayload = {
            requestNumber: requestNumber,
            appName: appName,
            queue: queueName,
            prociId: auditRequestData?.appProciIDMap[appName]?.[0]
        };
        console.log("Send Reminder Payload:", sendReminderPayload);
        setSendReminderPayload(sendReminderPayload);
        setIsShowModel(true)
    }

    const isReminder = (lastReminder) => {
        if (lastReminder) {
            const reminderDate = new Date(lastReminder.replace(' ', 'T'));
            const now = new Date();
            const diffHours = (now - reminderDate) / (1000 * 60 * 60);
            setDisabled(diffHours <= 24);
        }
    }

    const getDataByStatus = (status, auditRequestData) => {
        const map =
            status.toLowerCase() === "complete"
                ? auditRequestData?.finalAttributeMap
                : auditRequestData?.tempAttributeMap;
        const appNames = auditRequestData?.distinctAppsList || [];
        const appName = requestedAppName ? requestedAppName : appNames[0];
        const auditAdditionalData = map?.[appName] || {};


        if (!auditAdditionalData || Object.keys(auditAdditionalData).length === 0) {
            setRequestDetail([]);
            return;
        }

        const keyValueArray = Object.entries(auditAdditionalData).map(([key, value]) => ({
            key,
            value
        }));

        console.log("UPDATING UI WITH:", keyValueArray);

        setRequestDetail([...keyValueArray]);
    };


    const onChangeAppName = async (appName) => {
        setAppName(appName);
        let filteredData = auditRequestData?.workItemsMap?.[appName] || [];
        let approverDetailsMap = auditRequestData?.approverDetailsMap?.[appName] || [];
        const transformedData = filteredData.map((item) => ({
            approverQueue: ["", "null", null, undefined, "undefined"].includes(item?.queueName) ? t("auditRequest.not_applicable") : item.queueName,
            arrivedInQueue: ["", "null", null, undefined, "undefined"].includes(item?.dateArrived) ? t("auditRequest.not_applicable") : item.dateArrived,
            status: ["", "null", null, undefined, "undefined"].includes(item?.status) ? t("auditRequest.not_applicable") : item.status,
            dateCompleted: ["", "null", null, undefined, "undefined"].includes(item?.dateApproved) ? t("auditRequest.not_applicable") : item.dateApproved,
            approver: ["", "null", null, undefined, "undefined"].includes(item?.approverGpid) ? t("auditRequest.not_applicable") : item.approverGpid,
        }));


        const transformedRoutingData = Array.isArray(approverDetailsMap)
            ? approverDetailsMap.filter((data) => `${data.fullName}`.trim?.()?.toLowerCase() !== "imyidMTeamServiceITE"?.toLowerCase?.() && Boolean(`${data.fullName}`.trim() || `${data.email}`.trim() || `${data.phoneNumber}`.trim() || `${data.ext}`.trim() || `${data.currentApproverGPID}`.trim())).map((item) => ({
                approver: ["", "null", null, undefined, "undefined"].includes(item?.fullName)
                    ? t("auditRequest.not_applicable")
                    : item.fullName,
                email: ["", "null", null, undefined, "undefined"].includes(item?.email)
                    ? t("auditRequest.not_applicable")
                    : item.email,
                phoneNumber: ["", "null", null, undefined, "undefined"].includes(item?.phoneNumber)
                    ? t("auditRequest.not_applicable")
                    : item.phoneNumber,
                ext: ["", "null", null, undefined, "undefined"].includes(item?.ext)
                    ? t("auditRequest.not_applicable")
                    : item.ext,
                gpid: ["", "null", null, undefined, "undefined"].includes(item?.currentApproverGPID)
                    ? t("auditRequest.not_applicable")
                    : item.currentApproverGPID,
            }))
            : [];
        let approverQueueData = [];
        const status = selected === t("auditRequest.request_completed_label") ? "Complete" : "Submitted";
        approverQueueData = status === "Complete" ? transformedData.filter((a) => a.status.toLowerCase() == "approved") : transformedData;
        // approverQueueData = transformedData;
        setRoutingList(transformedRoutingData);
        setApproverQueue(approverQueueData);
        setApproverQueueList(transformedData);
        getDataByStatus(status, auditRequestData);
    }



    const renderToastContainer = () => {
        return (
            <ToastContainer
                position="bottom-center"
                autoClose={5000}
                hideProgressBar={false}
                closeOnClick
                pauseOnHover
                draggable
            />
        )
    }

    const renderTabInfoContainer = () => {
        return (
            <div className="request-support-info-container">
                <div>
                    <Icon
                        alt="alt value"
                        icon="info"
                        size="small"
                        style={{ marginRight: '6px', display: 'unset' }}
                    />
                    <small>
                        {t("auditRequest.before_sending_reminder_label")}
                    </small>
                </div>
                <Button
                    className=""
                    size="medium"
                    style={{}}
                    text={t("auditRequest.remind_approvers_label")}
                    variant="primary"
                    disabled={disabled}
                    onClick={() => onClickReminder()}
                />
            </div>
        )
    }


    const renderTabNavigationContent = () => {
        return (
            <>
                <div className="request-detail-tab">
                    <TabsNavigation selectedIndex={selectedIndex}>
                        <Tab label={t("auditRequest.approver_queue_label")} onClick={() => setSelectedIndex(0)} />
                        {(auditRequestData?.overAllStatus !== 'Failed' && auditRequestData?.overAllStatus !== 'Complete') && (
                            <Tab label={t("auditRequest.routing_support_label")} onClick={() => setSelectedIndex(1)} />
                        )}

                    </TabsNavigation>
                    <div className="tab-content">
                        {selectedIndex === 0 && (
                            <DataTable
                                className="datatable audit-request-table"
                                columns={columns}
                                data={approverQueue}
                                isResizable={false}
                                enableSorting={true}
                                onColumnFiltersChange={function oFe() { }}
                                onGlobalSearchChange={function oFe() { }}
                                manualPagination={true}
                                pageSize={10}
                                totalRowsCount={50}
                                renderSubComponent={function oFe() { }}
                                rowExpandingHandler={function oFe() { }}
                                searchPlaceholder="Type a search keyword"
                                selection="single"
                                showColumnFilters={false}
                                showDescription={false}
                                showFilterButton={false}
                                showFilterToolbar={false}
                                showMultiSortMenu={false}
                                showPagination={true}
                                showSearchOption={false}
                                showTableHeader={false}
                                showTitle={false}
                                size="large"
                                sortingHandler={function oFe() { }}
                                style={{}}
                                tableDescription="Search for a user using a criteria"
                                tableHeader="Extension for others"

                            />
                        )}

                        {selectedIndex === 1 && (
                            <>
                                {/* {(!isMobile) && auditRequestData.isFollowupEnabled && (renderTabInfoContainer())} */}
                                {(!isMobile) && (
                                    <small style={{ color: '#616161', marginBottom: '4px' }}>{t("auditRequest.associates_involved_label")}</small>
                                )}

                                <DataTable
                                    className="datatable audit-request-table"
                                    columns={requestSupportColumns}
                                    data={routingList}
                                    isResizable={false}
                                    enableSorting={true}
                                    onColumnFiltersChange={function oFe() { }}
                                    onGlobalSearchChange={function oFe() { }}
                                    manualPagination={true}
                                    pageSize={10}
                                    totalRowsCount={50}
                                    renderSubComponent={function oFe() { }}
                                    rowExpandingHandler={function oFe() { }}
                                    searchPlaceholder="Type a search keyword"
                                    selection="single"
                                    showColumnFilters={false}
                                    showDescription={false}
                                    showFilterButton={false}
                                    showFilterToolbar={false}
                                    showMultiSortMenu={false}
                                    showPagination={true}
                                    showSearchOption={false}
                                    showTableHeader={false}
                                    showTitle={false}
                                    size="large"
                                    sortingHandler={function oFe() { }}
                                    style={{}}
                                    tableDescription="Search for a user using a criteria"
                                    tableHeader="Extension for others"

                                />
                            </>

                        )}
                    </div>
                </div>

            </>
        );
    }

    const onChangeStatus = (item) => {
        setSelected(item);
        let approvalData = [];
        if (item == t("auditRequest.request_completed_label")) {
            approvalData = approverQueueList.filter((a) => a.status.toLowerCase() === "approved");
            getDataByStatus("complete", auditRequestData);
        } else {
            approvalData = approverQueueList;
            getDataByStatus("submited", auditRequestData);
        }
        setApproverQueue(approvalData);
    }

    return (
        <div id="audit_requests" className="request-modal-overlay">
            <div className="request-modal-content">
                {(isLoading) ? (<div>{t("auditRequest.loading_label")}</div>) : error ? (<div style={{ display: "flex", justifyContent: 'space-between' }}>
                    {/* {error} */}
                    <div className="d-flex justify-content-center" style={{flexGrow:"1"}}><ServiceUnavailable /></div>
                    <Icon
                        alt="alt value"
                        icon="close"
                        size="large"
                        style={{ display: 'unset' }}
                        onClick={onClose}
                    />
                </div>) :
                    ((appNameLoading) ? <div>{t("auditRequest.loading_label")}</div> :
                        <>
                            <div className="request-modal-header">
                                <div className="request-header-content">
                                    <div style={{ display: 'flex', gap: '12px' }}>
                                        <p>{t("auditRequest.request_details_label")}</p>
                                        <div
                                            className="status-tag"
                                            style={{
                                                backgroundColor: getBackgroundColor(
                                                    auditRequestData?.overAllStatus)
                                            }}
                                        >
                                            {auditRequestData?.overAllStatus}
                                        </div>
                                    </div>
                                    <Icon
                                        alt="alt value"
                                        icon="close"
                                        size="large"
                                        style={{ display: 'unset' }}
                                        onClick={onClose}
                                    />
                                </div>

                            </div>
                            <div className="request-body-content">
                                {auditRequestData?.distinctAppsList?.length > 1 && (
                                    <div style={{ marginBottom: "16px" }}>
                                        <Dropdown
                                            childList={
                                                auditRequestData.distinctAppsList.map((item, index) => ({
                                                    displayText: item,
                                                    id: index.toString(),
                                                })).sort((a, b) => { return a.displayText.localeCompare(b.displayText); })
                                            }
                                            className="request-app-dropdown"
                                            isClearable={false}
                                            isRequired={false}
                                            menuPosition="bottom-right"
                                            placeholder={auditRequestData?.distinctAppsList?.[0]} selection="single"
                                            setSelectedValue={(selected) => {
                                                console.log("Selected app:", selected);
                                                onChangeAppName(selected[0].displayText);
                                            }}
                                            size="medium"
                                            onKeyDown={(e) => e.preventDefault()}
                                        />
                                    </div>
                                )}


                                <AccordionV2
                                    accordionTitle="Accordion Title"
                                    className="request-detail-accordion"
                                    onClickAdd={function oFe() { }}
                                    onUpdate={function oFe() { }}
                                    presentation="border"
                                    separator
                                    style={{}}
                                    size="small"
                                >
                                    <AccordionItemV2
                                        label={t("auditRequest.request_summary_label")}
                                        onUpdate={function oFe() { }}
                                        presentation="box-shadow"
                                    >
                                        <div className="request-summary-detail">
                                            <div>
                                                <DetailItem label={t("auditRequest.requested_for")} value={auditRequestData?.subjectGpid} />
                                            </div>
                                            <div>
                                                <DetailItem label={t("auditRequest.requested_by")} value={auditRequestData?.initiatorGpid} />
                                            </div>

                                        </div>
                                    </AccordionItemV2>
                                </AccordionV2>

                                {(approverQueue.length > 0 || approverQueueList.length > 0 || requestDetail.length > 0) ? <div className="audit-request-detail-container">
                                    {(approverQueue.length > 0 || approverQueueList.length > 0) ? <div className="audit-request-detail-header">
                                        <span className="request-detail-title">{t("auditRequest.request_details_upper_label")}</span>
                                        <div className="audit-request-detail-header-options">

                                            <div
                                                style={{
                                                    display: isMobile ? "block" : "flex",
                                                    gap: "1rem"
                                                }}
                                            >
                                                {items.map((item) => (
                                                    <label
                                                        key={item}
                                                        style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
                                                    >
                                                        <input
                                                            type="radio"
                                                            name={t("auditRequest.request_status")}
                                                            value={item}
                                                            checked={selected === item}
                                                            onChange={() => onChangeStatus(item)}
                                                        />
                                                        {item}
                                                    </label>
                                                ))}
                                            </div>

                                        </div>
                                    </div> : null}
                                    {requestDetail.length > 0 && (
                                        <>
                                            <div
                                                className={`${!isMobile
                                                    ? "requested-summary-section"
                                                    : "requested-summary-section-mobile"
                                                    }`}
                                            >
                                                {requestDetail.map((item, idx) => (
                                                    <div className="request-detail-item">
                                                        <div className="request-detail-item-label" dangerouslySetInnerHTML={{ __html: `${item.key.includes(":") ? item.key : `${item.key}:`}` }} />
                                                        {item.value.includes("~") ? item.value?.split?.('~')?.map((val)=> <span className="request-detail-item-value">{val}</span>): <span className="request-detail-item-value">{item.value}</span>}
                                                    </div>
                                                    // <DetailItem
                                                    //     key={idx}
                                                    //     label={item.key}
                                                    //     value={item.value}
                                                    // />
                                                ))}
                                            </div>
                                        </>
                                    )}

                                    {/* {(isMobile && auditRequestData.isFollowupEnabled && selectedIndex === 1) && (renderTabInfoContainer())} */}
                                    {(isMobile) && (renderTabNavigationContent())}
                                </div> : null}

                                {renderToastContainer()}

                                {(!isMobile) && (renderTabNavigationContent())}

                            </div>

                            <Modal
                                className="remind-approve-modal"
                                onCloseModal={() => {
                                    setIsShowModel(false);
                                }}
                                primaryButtonProps={{
                                    size: "medium",
                                    text: t("auditRequest.send_a_reminder_label"),
                                    variant: "primary",
                                    onClick: () => {
                                        setIsShowModel(false);
                                        setIsShowReminderModel(true);
                                    },
                                }}
                                secondaryButtonProps={{
                                    size: "medium",
                                    text: t("auditRequest.cancel_label"),
                                    variant: "secondary",
                                    onClick: () => {
                                        setIsShowModel(false);
                                    },
                                }}
                                showTertiaryButton={false}
                                showAuxiliaryButton={false}
                                showLink={false}
                                showModal={isShowModel}
                                style={{}}
                                text={t("auditRequest.friendly_reminder_label")}
                                title={t("auditRequest.reminder_stage_label")}
                                type="fluid"
                                viewPort={isMobile ? "mobile" : "desktop"}

                            ></Modal>

                            <Modal
                                className="remind-approve-modal"
                                
                                onCloseModal={() => setIsShowReminderModel(false)}
                                primaryButtonProps={{
                                    size: "medium",
                                    text: isBtnLoading ? t("auditRequest.submitting_label") : t("auditRequest.remind_all_label"),
                                    disabled: isBtnLoading,
                                    variant: "primary",
                                    onClick: () => {
                                        sendReminder();
                                    },
                                }}
                                secondaryButtonProps={{
                                    size: "medium",
                                    text: t("auditRequest.cancel_label"),
                                    variant: "secondary",
                                    onClick: () => setIsShowReminderModel(false),
                                }}
                                showTertiaryButton={false}
                                showAuxiliaryButton={false}
                                showLink={false}
                                showModal={isShowReminderModel}
                                text={t("auditRequest.friendly_reminder_label")}
                                title={t("auditRequest.reminder_stage_label")}
                                type="fluid"
                                viewPort={isMobile ? "mobile" : "desktop"}
                            >
                                {approverQueueList.filter(a => a.status.toLowerCase() != "approved").map((item, index) => {
                                    const gpid = item?.approverQueue || t("auditRequest.not_applicable");
                                    // const managerName = item?.approver || "N/A";
                                    const sentDate = item?.arrivedInQueue || t("auditRequest.not_applicable");
                                    const approvedDate = item?.dateCompleted || t("auditRequest.not_applicable");
                                    const status = item?.status || t("auditRequest.not_applicable");

                                    return (
                                        <div
                                            key={index}
                                            style={{
                                                color: "var(--Tokens-Text-Primary, #3A3A3A)",
                                                fontSize: "12px",
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: "0px",
                                                padding: "16px",
                                                border: "1px solid #ccc",
                                                borderRadius: "8px",
                                                marginBottom: "8px",
                                            }}
                                        >
                                            <div>
                                                {/* <strong>Manager name:</strong> {managerName} */}
                                                {/* <br /> */}
                                                {gpid}
                                            </div>

                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                }}
                                            >
                                                <div>
                                                    <span style={{ fontWeight: 500 }}>{t("auditRequest.sent_on_label")}:</span>
                                                    {sentDate}
                                                    <br />
                                                    <span style={{ fontWeight: 500 }}>{t("auditRequest.approved_on_label")}:</span>
                                                    {approvedDate}
                                                </div>

                                                <div
                                                    style={{
                                                        backgroundColor:
                                                            status === "Approved"
                                                                ? "#B3DACB"
                                                                : status === "Rejected"
                                                                    ? "#F8D7DA"
                                                                    : "#FFE599",
                                                        padding: "4px 8px",
                                                        borderRadius: "4px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: "4px",
                                                    }}
                                                >
                                                    {status === "Approved" && (
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="15"
                                                            height="15"
                                                            viewBox="0 0 48 48"
                                                        >
                                                            <path
                                                                fill="#43A047"
                                                                d="M40.6 12.1L17 35.7 7.4 26.1 4.6 29 17 41.3 43.4 14.9z"
                                                            ></path>
                                                        </svg>
                                                    )}
                                                    <span style={{ fontWeight: 500 }}>{status}</span>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}

                            </Modal>

                        </>
                    )}

            </div>
        </div>
    );
};

function DetailItem({ label, value }) {
    return (
        <div className="request-detail-item">
            <span className="request-detail-item-label">{label}:</span>
            {value.includes("~") ? value?.split?.('~')?.map((val)=> <span className="request-detail-item-value">{val}</span>): <span className="request-detail-item-value">{value}</span>}
            {/* <span className="request-detail-item-value">{value}</span> */}
        </div>
    );
}

export default AuditRequestDetail;
